import React from "react";
import { Card, CardBody, CardHeader, Badge, Row, Col } from "reactstrap";

const CiudadLimpiaTab = ({ contact }) => {
  const catastros = contact?.catastros_ciudad_limpia || [];

  const getBadgeColor = (value) => {
    if (value === "S") return "success";
    if (value === "N") return "danger";
    return "primary";
  };

  const formatDate = (dateString) => {
    if (!dateString) return "No especificada";
    return dateString;
  };
console.log(contact);

  return (
    <CardBody className="p-0">
      <h5 className="mb-4">Información Catastral Ciudad Limpia</h5>
      
      {catastros.length === 0 ? (
        <div className="text-center py-4">
          <p>No se encontró información catastral</p>
        </div>
      ) : (
        catastros.map((catastro, index) => (
          <Card key={index} className="mb-4">
            <CardHeader className="bg-light">
              <h6 className="mb-0">Cuenta: {catastro.cuenta_contrato || "N/A"}</h6>
            </CardHeader>
            <CardBody>
              <Row>
                {/* Columna 1 - Información básica */}
                <Col md={6}>
                  <div className="mb-3">
                    <h6 className="text-primary">Información Básica</h6>
                    <hr className="mt-1 mb-2" />
                    <Row className="text-muted">
                      <Col xs={6}>
                        <p><strong>Suscriptor:</strong> {catastro.suscriptor || "N/A"}</p>
                        <p><strong>Estrato:</strong> {catastro.estrato || "N/A"}</p>
                        <p><strong>Estado:</strong> 
                          <Badge color={getBadgeColor(catastro.estado)} className="ml-2">
                            {catastro.estado === "N" ? "Inactivo" : "Activo"}
                          </Badge>
                        </p>
                      </Col>
                      <Col xs={6}>
                        <p><strong>Fecha Ingreso:</strong> {formatDate(catastro.fecha_ingreso)}</p>
                        <p><strong>Tipo Facturación:</strong> {catastro.tipo_facturacion || "N/A"}</p>
                        <p><strong>Tipo Población:</strong> {catastro.tipo_poblacion || "N/A"}</p>
                      </Col>
                    </Row>
                  </div>

                  <div className="mb-3">
                    <h6 className="text-primary">Ubicación</h6>
                    <hr className="mt-1 mb-2" />
                    <p className="text-muted"><strong>Barrio:</strong> {catastro.codigo_barrio || "N/A"}</p>
                    <p className="text-muted"><strong>Manzana:</strong> {catastro.manzana || "N/A"}</p>
                    <p className="text-muted"><strong>Lote:</strong> {catastro.lote || "N/A"}</p>
                    <p className="text-muted"><strong>Coordenadas:</strong> {catastro.coordenadax}, {catastro.coordenaday}</p>
                  </div>
                </Col>

                {/* Columna 2 - Servicios y características */}
                <Col md={6}>
                  <div className="mb-3">
                    <h6 className="text-primary">Servicios</h6>
                    <hr className="mt-1 mb-2" />
                    <Row className="text-muted">
                      <Col xs={6}>
                        <p><strong>Recolección:</strong> {catastro.recoleccion || "N/A"}</p>
                        <p><strong>Barrido:</strong> {catastro.barrido || "N/A"}</p>
                        <p><strong>Puerta a puerta:</strong> 
                          <Badge color={catastro.puertaapuerta === "S" ? "success" : "danger"} className="ml-2">
                            {catastro.puertaapuerta === "S" ? "Sí" : "No"}
                          </Badge>
                        </p>
                      </Col>
                      <Col xs={6}>
                        <p><strong>Microrecolección:</strong> {catastro.microrecoleccion || "N/A"}</p>
                        <p><strong>Microbarrido:</strong> {catastro.microbarrido || "N/A"}</p>
                        <p><strong>ASE:</strong> {catastro.ase || "N/A"}</p>
                      </Col>
                    </Row>
                  </div>

                  <div className=" mb-3 text-muted">
                    <h6 className="text-primary">Características</h6>
                    <hr className="mt-1 mb-2" />
                    <p><strong>Tipo Productor:</strong> {catastro.tipo_productor || "N/A"}</p>
                    <p><strong>Descripción:</strong> {catastro.descripcion_tipoproductor || "N/A"}</p>
                    <p><strong>Uso Especial:</strong> {catastro.uso_especial || "N/A"}</p>
                    <p><strong>Volumen:</strong> {catastro.volumen || "0"}</p>
                  </div>
                </Col>
              </Row>

              {/* Sección inferior - Datos técnicos */}
              <div className="mt-3">
                <h6 className="text-primary">Datos Técnicos</h6>
                <hr className="mt-1 mb-2" />
                <Row className="text-muted">
                  <Col xs={4}>
                    <p><strong>CHIP:</strong> {catastro.chip || "N/A"}</p>
                    <p><strong>Ciclo:</strong> {catastro.ciclo || "N/A"}</p>
                  </Col>
                  <Col xs={4}>
                    <p><strong>Alcaldía:</strong> {catastro.alcaldia || "N/A"}</p>
                    <p><strong>UH:</strong> {catastro.uh || "N/A"}</p>
                  </Col>
                  <Col xs={4}>
                    <p><strong>UNH:</strong> {catastro.unh || "N/A"}</p>
                    <p><strong>Tipo Aforo:</strong> {catastro.tipoaforo || "N/A"}</p>
                  </Col>
                </Row>
              </div>
            </CardBody>
          </Card>
        ))
      )}
    </CardBody>
  );
};

export default CiudadLimpiaTab;